import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useMemo } from 'react';
import { useRef } from 'react';
import { Row } from 'react-bootstrap';
import NavItem from './NavItem';
import "./style.scss";
import { makeid } from 'helpers/random';

const NavBarContext = createContext(null);
export {NavBarContext};

function NavBar({
  onChange, children, defaultKey, addAll
}){

  const [ navItems, setNavItems ] = useState({});
  const [ selectedKey, setSelectedKey ] = useState(defaultKey);
  const refAllItems = useRef();

  const addNavItem = useCallback((navItem,quantity)=>{
    let id = makeid(12)
    navItem.current.onclick = () => setSelectedKey(navItem.current.getAttribute("data-event-key"));

    setNavItems(data => {
      data[id] = {ref:navItem.current, quantity}
      return {...data}
    });

    return id;
  },[addAll]);

  const removeNavItem = useCallback((id)=>{
    setNavItems(data => {
      delete data[id];
      return {...data}
    });
  },[addAll]);

  useEffect(()=>{
    let list = Object.values(navItems)
    if(refAllItems && refAllItems.current){
      list.push({ref:refAllItems.current})
    }
    list.forEach(({ref})=>{
      if(selectedKey === ref.getAttribute("data-event-key")){
        ref.classList.add("col-nav-bar-item-active")
      } else {
        ref.classList.remove("col-nav-bar-item-active")
      }
    })
    if(onChange){
      onChange(selectedKey)
    }
  },[selectedKey, navItems, onChange, refAllItems]);

  const total = useMemo(()=>{
    return Object.values(navItems).reduce((total, value)=>total+value.quantity,0)
  },[navItems])

  const eventKey = useMemo(()=>{
    return Object.values(navItems).map(({ref})=>ref.getAttribute("data-event-key")).join(',');
  },[navItems]) 

  useEffect(() => {
    if(!defaultKey){
      setSelectedKey(eventKey);
    }
  },[defaultKey,eventKey])

  return (
    <NavBarContext.Provider value={{
      addNavItem,
      removeNavItem
    }}>
      <section className="w-100 nav-bar">
        {children}
        {addAll?(
          <div ref={refAllItems} className="col-nav-bar-item" data-event-key={eventKey} onClick={()=>{
            setSelectedKey(eventKey)
          }}>
            <div className="nav-bar-item">Todos</div>
            {Number.isInteger(total)?<span className="badge badge-light nav-bar-quantity">{total}</span>:<></>}
          </div>
        ):<></>}
      </section>
    </NavBarContext.Provider>
  );
}

export default Object.assign(NavBar, {
  Item: require("./NavItem").default
})